import React, { ReactNode } from "react";
import { Button, ConfigProvider, Modal } from "antd";

interface ModalComponentProps {
  title: ReactNode;
  children?: ReactNode;
  withButton?: boolean;
  buttonText?: string;
  open?: boolean;
  buttonStyle?: React.CSSProperties;
  modalStyle?: React.CSSProperties;
  onClose?: () => void;
  closeOnOutsideClick?: boolean;
  width?: number | string;
  showCloseIcon?: boolean;
  className?: string;
  /** Added to Ant Design Modal `root` (mask + wrap) for styling the overlay. */
  rootClassName?: string;
  /** Use the same purple gradient + blur mask as the canvas sidebar (`.ac-canvas-backdrop`). */
  canvasBackdrop?: boolean;
  centered?: boolean;
  destroyOnClose?: boolean;
  /** For accessibility when `title` is null (e.g. custom heading inside body). */
  dialogAriaLabelledBy?: string;
}

const ModalComponent: React.FC<ModalComponentProps> = ({
  title,
  children,
  withButton = false,
  buttonText = "Open Modal",
  buttonStyle,
  modalStyle,
  open = false,
  onClose,
  closeOnOutsideClick,
  width,
  showCloseIcon = true,
  className,
  rootClassName,
  canvasBackdrop,
  centered,
  destroyOnClose,
  dialogAriaLabelledBy,
}) => {
  const rootClass = [canvasBackdrop && "ac-modal-canvas-overlay", rootClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      {withButton && (
        <ConfigProvider wave={{ disabled: true }}>
          <Button style={buttonStyle}>{buttonText}</Button>
        </ConfigProvider>
      )}

      <Modal
        rootClassName={rootClass || undefined}
        aria-labelledby={dialogAriaLabelledBy}
        style={{
          top: centered ? undefined : 20,
          paddingBottom: 0,
          ...modalStyle,
        }}
        width={width}
        open={open}
        footer={null}
        title={title}
        onClose={onClose}
        onCancel={closeOnOutsideClick ? onClose : undefined}
        closable={showCloseIcon}
        className={className}
        centered={centered}
        destroyOnClose={destroyOnClose}
      >
        {children}
      </Modal>
    </>
  );
};

export default ModalComponent;
